
import React from "react";

const CheckoutCancel = () => {
  return <div style={{maxWidth: 520, margin: "10vh auto", textAlign: "center", fontFamily: "system-ui"}}> You opened this page from an email link. If you didn’t mean to cancel,
        just go back to your email and click the payment link again.</div>;
};

export default CheckoutCancel;
